import { ReactNode } from "react";
import Content from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Content/Content";
import TopRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TopRow/TopRow";
import TopRowMain from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TopRowMain/TopRowMain";
import Badges from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Badges/Badges";
import Indicators from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Indicators/Indicators";
import BottomRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/BottomRow/BottomRow";
import Assigned from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Assigned/Assigned";
import TaskType from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TaskType/TaskType";
import Date from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Date/Date";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";

type PendingTaskCardProps = {
  children: ReactNode;
  taskType: string | Loading;
  priority: boolean;
  safetyAlarm?: boolean;
  date: string | Loading;
  assigned: string | Loading;
  startElement: ReactNode | Loading;
  hasFile?: boolean;
  hasImage?: boolean;
  hasComment?: boolean;
};

function PendingTaskCard({
  children,
  taskType,
  priority,
  safetyAlarm,
  date,
  assigned,
  startElement,
  hasFile,
  hasImage,
  hasComment,
}: PendingTaskCardProps) {
  return (
    <Content>
      <TopRow>
        <TopRowMain>
          <TaskType value={taskType} />
          <Badges priority={priority} safetyAlarm={safetyAlarm} />
        </TopRowMain>
        <Indicators
          hasFile={hasFile}
          hasImage={hasImage}
          hasComment={hasComment}
        />
      </TopRow>
      {children}
      {!isLoading(startElement) && startElement}
      <BottomRow>
        <Assigned value={assigned} />
        <Date value={date} />
      </BottomRow>
    </Content>
  );
}

export default PendingTaskCard;
